import { render, staticRenderFns } from "./StudentExamEvaluation.vue?vue&type=template&id=bb22a562"
import script from "./StudentExamEvaluation.vue?vue&type=script&lang=js"
export * from "./StudentExamEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports